const meetingResolutionStatuses = Object.freeze({
  accepted: 1,
  rejected: 2,
  notResolved: 3,
  sansVote: 4,
  // status for Demarre le vote
  started: 5,
  corrected: 6,
  rejected_lack_of_majority: 7,
});

export { meetingResolutionStatuses };
